export default __webpack_public_path__ + "static/media/detail_footer.af32c88f.png";